import { httpClient } from './httpClient';

export interface Source {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const sourceService = {
    getAllSources: async () => {
        try {
            return await httpClient.get<Source[]>('/api/sources');
        } catch (error) {
            return [];
        }
    },

    getSourceById: async (id: number) => {
        return httpClient.get<Source>(`/api/sources/${id}`);
    },

    createSource: async (name: string, description?: string) => {
        return httpClient.post<Source>('/api/sources', { name, description });
    },

    updateSource: async (id: number, name: string, description?: string) => {
        return httpClient.put<Source>(`/api/sources/${id}`, { name, description });
    },

    deleteSource: async (id: number) => {
        return httpClient.delete<Source>(`/api/sources/${id}`);
    }
};
